import api from './api'

export interface AutoAssignOperator {
    id: number
    username: string
    full_name: string | null
    role: string
    is_active: boolean
    enabled: boolean
    lead_count: number
}

export interface AutoAssignSettings {
    enabled: boolean
    last_operator_id: number | null
    last_operator_name: string | null
    updated_at: string | null
    operators: AutoAssignOperator[]
}

// Автораспределение ответивших лидов. Доступно тем же ролям, что и остальные
// настройки: «Админ ЛПЕ» и «Админ разработки».
export const autoAssignApi = {
    get: () => api.get<AutoAssignSettings>('/auto-assign'),

    update: (data: { enabled?: boolean }) =>
        api.put<AutoAssignSettings>('/auto-assign', data),

    toggleOperator: (operatorId: number, enabled: boolean) =>
        api.put<AutoAssignSettings>(`/auto-assign/operators/${operatorId}`, { enabled }),
}
